/**
 * WebSyncHttpClient — browser implementation of SyncHttpClient.
 *
 * Wraps apiFetch (non-throwing) and apiFetchOrThrow from api/client.ts.
 */

import type { SyncHttpClient } from "../../types";
import { apiFetch, apiFetchOrThrow } from "../../api/client";

export class WebSyncHttpClient implements SyncHttpClient {
  async fetch<T>(
    path: string,
    options?: { method?: string; body?: string },
  ): Promise<T | null> {
    return apiFetch<T>(path, options);
  }

  async fetchOrThrow<T>(
    path: string,
    options?: { method?: string; body?: string },
  ): Promise<T> {
    return apiFetchOrThrow<T>(path, options);
  }
}
